import { render, staticRenderFns } from "./layout-sider.vue?vue&type=template&id=055730d2&"
import script from "./layout-sider.vue?vue&type=script&lang=js&"
export * from "./layout-sider.vue?vue&type=script&lang=js&"
import style0 from "./layout-sider.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "layout-sider.vue"
export default component.exports